import React, { useEffect, useState } from 'react'
import { contentService } from '../../services/content.service'
import { SplitScreenContext } from '../../layouts/SplitScreenLayout'

export const termsOfUseContext: SplitScreenContext = {
  id: 'terms-of-use',
  title: 'Terms of <em>Use</em>',
  message: '',
  contentSide: 'left',
  logoSrc: '/images/landing-v2/logo.png',
  variant: 'v2',
}

const TermsOfUsePage = () => {
  const [termsOfUse, setTermsOfUse] = useState<string>('')

  useEffect(() => {
    const handleLoad = async () => {
      try {
        const content = await contentService.getTermsOfUse()
        setTermsOfUse(content)
      } catch (error) {
        console.error('Retrieving terms of use failed:', error)
      } finally {
      }
    }
    handleLoad()
  }, [])

  return <div className="legal-content" dangerouslySetInnerHTML={{ __html: termsOfUse }} />
}

export default TermsOfUsePage
